import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              视频分类
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              海量资源随心选，总有你喜欢的
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
            {videoCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}